import { createElement } from "react";

// Site photos have a lighter 900 px copy in /img/emma/m/ (backend/scripts/optimize_images.py).
// <Pic> serves it to phones (screens up to 767 px wide), the full photo to larger screens.
// <picture> uses display: contents (index.css), so the <img> keeps laying out exactly as before.
const phone = (src) => (typeof src === "string" && /^\/img\/emma\/[^/]+\.jpg$/.test(src) ? src.replace("/img/emma/", "/img/emma/m/") : null);

export const Pic = ({ as = "img", ...props }) => {
  const img = createElement(as, props);
  const m = phone(props.src);
  return m ? (
    <picture>
      <source media="(max-width: 767px)" srcSet={m} />
      {img}
    </picture>
  ) : img;
};
